export default function useAlgolia() {
  const {
    public: { algolia },
  } = useRuntimeConfig()

  const defaultIndex = useAlgoliaInitIndex(algolia.globalIndex)
  const sortNameAscIndex = useAlgoliaInitIndex(
    `${algolia.globalIndex}_name:asc`,
  )
  const sortNameDescIndex = useAlgoliaInitIndex(
    `${algolia.globalIndex}_name:desc`,
  )
  const sortDateDescIndex = useAlgoliaInitIndex(
    `${algolia.globalIndex}_date:desc`,
  )

  return {
    defaultIndex,
    sortNameAscIndex,
    sortNameDescIndex,
    sortDateDescIndex,
  }
}
